import constants from './constants';

function setButtonState(buttonState) {
  return dispatch => {
    dispatch({
      type: constants.SET_BUTTON_STATE,
      buttonState,
    });
  };
}

export default { setButtonState };



// WEBPACK FOOTER //
// ./src/features/Button/actions.js